import { createSlice } from "@reduxjs/toolkit";

const initialState = [
    { value: "10", label: "10개씩 보기" },
    { value: "30", label: "30개씩 보기" },
    { value: "50", label: "50개씩 보기" },
    { value: "100", label: "100개씩 보기" },
];
export const areaOptionsSlice = createSlice({
    name: "perPageOptions",
    initialState: initialState,
    reducers: {
    }
})

export default areaOptionsSlice.reducer;